<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" 
  infinite
  :infinite-distance="50"
  :infinite-preloader="showPreloader"
  @infinite="loadMore"
  >
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("home_0180") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="content" v-if="newsbymemberlist.length>0">
      <!-- <div class="newsInfo" v-for="(item,index) in newsbymemberlist" :key="index" @click="$f7router.navigate(`/newsDetail/${item.Id}/`)">
        <div class="img"><img :src="`${ImagesURL}sr/picture/promotion/${item.PosterMobile}`" width="66" height="50" style="object-fit: cover;border-radius: 5px;border: 1px solid #ccc;"></div>
        <div class="bottom">
          <div class="title">{{ item.Title }}</div>
          <div class="time">{{ item.ReleaseTS | time2}}</div>
        </div>
      </div> -->
      <div class="listtitle"  v-for="(item,index) in newsbymemberlist" :key="index" @click="$f7router.navigate(`/newsDetail/${item.Id}/2/`)">
        <span>{{ item.Title }}</span>
        <i class="f7-icons jian" >chevron_right</i>
      </div>
    </div>
    <f7-card v-else-if="newsbymemberlist.length<=0 && !showData" class="no-data">
      <img :src="`../../static/images/yt999/noData_${ $f7.params.currLang }.png`" width="45%" :onerror="`this.onerror=''; src='../../static/images/yt999/noData_enUS.png'`" alt="No data" >
    </f7-card>

  </f7-page>
</template>

<script>
import { getStore } from "@/config/utils";
import {merchantMewsList,getCarouseladvertList } from "../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      ImagesURL: getStore('ImagesURL'),
      newsbymemberlist: [],
      allowInfinite: true,
      showPreloader: true,
      pageNow: 1,
      pageTotal: 0,
      showData: true,
      data: [],


      bannerList: [],
      bannerBaseUri: "",
      bannerShow: false,
      swiperParams: {
        speed: 700,
        loop: true,
        // autoplay: {
        //   disableOnInteraction: false,
        //   delay: 8000,
        // },
        lazy: {
          loadPrevNext: true,
        },
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    getnewsbymemberlist(){
      const self = this;
      const param = {"NewsType":3,"IsHot":false,"PageSize":50,"PageNow":self.pageNow};
      const d =  JSON.stringify(param) ;
      merchantMewsList(d).then((data) => {
        if (data.Code === "NoError") {
          self.data = data.Data;
          self.newsbymemberlist = self.newsbymemberlist.concat(
            data.Data
          );
          self.showData = self.newsbymemberlist.length > 0;

          self.showPreloader = false;
        }

      });
    },
    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      setTimeout(() => {
        if (self.data.length == 0) {
          self.showPreloader = false;
          return;
        }
        self.pageNow += 1;
        self.getnewsbymemberlist();
        self.allowInfinite = true;
      }, 1000);
    },
    getBannerList(param) {
      const self = this;
      getCarouseladvertList(param).then((data) => {
        if (data.Code === "NoError") {
          
          self.bannerList = data.Data;
          if (self.bannerList.length>1) {
            self.bannerShow = true;
            self.swiperParams.autoplay = { disableOnInteraction: false, delay: 5000 }
          }
        }
      });
    },
  },
  created() { 
    // this.getBannerList(7);
    this.bannerBaseUri = getStore("ImagesURL") + window.configs.carouseladvertImg;
    this.getnewsbymemberlist();
    this.$f7.emit("myCustomEvent", "newsList");

  },
  mounted() { 
    
  },
};
</script>
<style lang="less" scoped>
.content{
  padding: 0 10px 25px 10px;
  .newsInfo:nth-child(1){
    border-top: 1px solid #e5e5e5;
  }
  .newsInfo{
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding: 18px 0 ;
    display: flex;
    .img{
      width: 25%;
      font-size: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .bottom{
      width: 75%;
      .title{
        height: 40px;
        overflow: hidden;
      }
      .time{
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
      }
    }
  }
}
.listtitle{
  padding: 10px;
  border-radius: 7px;
  margin-top: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 35px;
  border: 1px solid #D8E8ED;
  font-weight: bold;
  .jian{
    font-size: 14px;
    position: absolute;
    right: 20px;
    top: 13px;
    color: #0786B3;
  }
}
.no-data {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 50%;
}
</style>